export const edkInfo = {
  version: '22.03.22.01'
}
